import axiosInstance from 'axiosInstance';

export const fetchProfiles = async () => {
  const response = await axiosInstance.get('login/profiles');
  return response.data;
};

export const createProfile = async payload => {
  const response = await axiosInstance.post('login/profiles', payload);
  return response.data;
};

export const deleteProfile = async profileId => {
  const response = await axiosInstance.delete(`login/profiles/${profileId}`);
  return response.data;
};

export const updateProfile = async (profileId, payload) => {
  const response = await axiosInstance.post(`login/profiles/${profileId}`, payload);
  return response.data;
};

export const fetchUsers = async () => {
  const response = await axiosInstance.get('login/users');
  return response.data;
};

export const createUser = async payload => {
  const response = await axiosInstance.post('login/users', payload);
  return response.data;
};

export const deleteUser = async membershipId => {
  const response = await axiosInstance.delete(`login/users/${membershipId}`);
  return response.data;
};

export const updateUser = async (membershipId, payload) => {
  const response = await axiosInstance.post(`login/users/${membershipId}`, payload);
  return response.data;
};
